"use client";
import React from "react";
import { useState } from "react";
import { Input } from "@/components/atoms/input";
import { type InputProps as HeadlessInputProps } from "@headlessui/react";

export const InputCurrency = ({
  currency = "NGN",
  ...props
}: {
  currency?: string;
  props?: HeadlessInputProps;
}) => {
  const [value, setValue] = useState("");

  function formatValue(val: string, currency: string) {
    if (!val) return "";
    const number = parseFloat(val.replace(/,/g, ""));
    if (isNaN(number)) return val;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = e.target.value.replace(/,/g, "").replace(/[^\d.-]/g, "");
    const cursorPosition = e.target.selectionStart || 0;
    const formattedValue = formatValue(val, currency);
    setValue(formattedValue);
    setTimeout(() => {
      const decimalIndex = formattedValue.indexOf(".");
      const newCursorPosition =
        cursorPosition + (formattedValue.length - val.length);

      if (cursorPosition > decimalIndex) {
        e.target.selectionStart = e.target.selectionEnd = newCursorPosition;
      } else {
        e.target.selectionStart = e.target.selectionEnd = Math.min(
          newCursorPosition,
          formattedValue.length - 3,
        );
      }
    }, 0);
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Backspace" && value.length === 1) {
      setValue("");
      e.preventDefault();
    }
  }

  return (
    <Input
      id="currency"
      name="currency"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder="0.00"
      {...props}
    />
  );
};
